


























import { Vue, Component, Prop, Question, QuestionType } from "@zoovu/runner-browser-api";
import { QuestionHeadView } from "@zoovu/runner-web-design-base";

@Component({
  name: "QuestionHeadView",
  mixins: [QuestionHeadView],
})
export default class QuestionHeadViewExtended extends Vue {
  @Prop()
  question!: Question;

  get shouldShowHint(): boolean {
    return this.question.questionType === QuestionType.CHECKBOX || this.question.questionType === QuestionType.RADIO;
  }
}
